import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getAlertTypes } from '../../services/AlertsService';
import { AlertTypesResponse } from '../../types/Alerts';

function useGetAlertTypes(fleetId: string, query = ''): UseQueryResult<AlertTypesResponse> {
  return useQuery(
    ['alert-types', fleetId, query],
    async (): Promise<AlertTypesResponse> => getAlertTypes(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetAlertTypes;
